<template>
  <v-card class="pa-4">

    <h1>Release Puppy</h1>

    <h2 v-if="puppy">
      {{ `${puppy.mainColor ? puppy.mainColor.toUpperCase() : ""} ${puppy.gender ? puppy.gender.toUpperCase() : ""}` }}
    </h2>
    <h3>{{ `Litter #${litterId}` }}</h3>

    <v-form class="login-form" v-model="isValid" @keyup.native.enter="isValid && submit()">
      <v-checkbox v-model="mayBreed" label="May Breed?" />
      <v-checkbox v-model="requireCoowner" label="Require self to be listed as co-owner?" />
      <v-select v-if="litterInfo" v-model="kennels" item-text="name" item-value="id" :items="litterInfo.kennels"
        outlined multiple label="Require kennel name(s) in dog’s name?" clearable class="mr-1" />
      <datepicker :formattedDate="transferDateFormatted" :date="transferDate" label="Date of ownership transfer"
        v-on:updateDates="updateDates($event, 'transferDate')" :rules="[(v) => !!v || 'Transfer date is required']" />
        <v-text-field outlined v-model="firstName" label="Firstname" :rules="[(v) => !!v || 'Firstname is required']" />
        <v-text-field outlined v-model="lastName" type="text" label="Lastname"
        :rules="[(v) => !!v || 'Lastname is required']" />
        <v-text-field outlined v-model="email" type="email" label="Email" :rules="[validateEmail]" />
        <p>A link to the Dog Registration form will be emailed to the new owner at the address provided.</p>
        <v-text-field outlined v-model="signature" type="text" label="Signature" :rules="[(v) => !!v || 'Signature is required']" />
          <p>The signature of the litter co-owner is required to release the dog. An email with a link to the appropriate form will be send to the address above. Release is not complete until the form is submitted.</p>
      <v-alert width="100%" v-model="isError" dismissible type="error">
        {{ errorMessage }}</v-alert>
      <v-btn :disabled="!isValid || isProcessing" v-on:click="submit" large color="primary" class="mb-5">Release
      </v-btn>
    </v-form>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";
import Datepicker from "@/components/common/inputs/DatepickerFormatted.vue";

import puppyReleaseService from "@/services/puppyReleaseService";
import litterService from "@/services/portal/litterService";
import { getErrorMessage } from "@/services/errorHandler";

import validateEmail from "@/helpers/validate-email";
import { getAscaToday } from "@/helpers/date-utils";

// TODO: Once time allows debounce the email validation here
export default Vue.extend({
  name: "ReleasePuppy",
  components: {
    Datepicker,
  },
  data: function () {
    return {
      litterInfo: null,
      puppy: null,
      mayBreed: false,
      requireCoowner: false,
      kennels: [],
      transferDateFormatted: "",
      transferDate: getAscaToday(),
      firstName: "",
      lastName: "",
      email: "",
      signature: "",
      isValid: false,
      isProcessing: false,
      errorMessage: "",
      isError: false,
    };
  },
  created: function () { this.loadInfo() },
  watch: {
    '$store.state.userInfo.personId': {
      handler() { this.loadInfo() }
    }
  },
  methods: {
    loadInfo: function () {
      if (this.litterId) {
        litterService
          .getLitterById(this.litterId)
          .then((res) => {
            this.litterInfo = res;
            this.puppy = res.puppies.find(({ id }: { id: number }) => id === this.puppyId)
          })
          .catch(this.$handleError);
      }
    },
    updateDates: function (val: any, key: string) {
      (this as any)[key + "Formatted"] = val.formattedDate;
      (this as any)[key] = val.date;
    },
    validateEmail(v: string) {
      return (
        validateEmail(v) ||
        'E-mail must be valid'
      );
    },
    submit: function () {
      this.errorMessage = '';
      this.isProcessing = true;
      puppyReleaseService
        .releasePuppy(
          this.puppyId,
          this.mayBreed,
          this.requireCoowner,
          this.kennels,
          this.transferDate,
          this.firstName,
          this.lastName,
          this.email,
          this.signature
        )
        .then((res) => {
          this.isProcessing = false;
          if (!res.success) {
            this.errorMessage = res.message;
            this.isError = true;
            return;
          }
          this.$router.push(`/litters/${this.litterId}`)
        })
        .catch((e) => {
          this.isError = true;
          this.isProcessing = false;
          this.errorMessage = getErrorMessage(e);
        });
    },
  },
  props: {
    puppyId: { type: Number },
    litterId: { type: Number },
  },
});
</script>
